module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "case-3"
    }
  }, [_c('h1', [_vm._v("Case 3")]), _vm._v(" "), _c('div', {
    staticClass: "section level21",
    attrs: {
      "id": "clinical-presentation-2"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "6px",
      "letter-spacing": "1px",
      "padding-top": "28px",
      "font-weight": "bold",
      "text-indent": "0px"
    }
  }, [_vm._v("Clinical Presentation")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A 60-year-old man complaining of right upper quadrant pain with abdominal distension after meals. He had a history of surgery for hydatid cysts of the liver 10 years ago. The physical examination was normal except moderate splenomegaly. The routine laboratory investigations were within normal limits.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level21",
    attrs: {
      "id": "radiological-findings-2"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "6px",
      "letter-spacing": "1px",
      "padding-top": "28px",
      "font-weight": "bold",
      "text-indent": "0px"
    }
  }, [_vm._v("Radiological Findings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "3",
      "src": "media/3.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "15px",
      "padding-bottom": "10px",
      "text-align": "center"
    }
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "none",
      "padding-right": "95px",
      "padding-left": "110px",
      "margin-top": "0px"
    }
  }, [_c('li', [_c('p', {
    staticStyle: {
      "text-indent": "20px"
    }
  }, [_c('strong', [_vm._v("Pre-(A, B) and post-contrast (C, D, E) abdominal CT scan with coronal reconstruction (F) images")]), _vm._v(" showing a dysmorphic liver (past history of surgery for hydatid cysts) with hydatid cysts located in the segments, VIII/VII (CE4 and CE3A, WHO classification) and V (CE3 A, WHO classification). The portal vein and its right branch are dilated, containing germinative membranes and other cyst contents with evidence of fistulous tract between the hydatid cyst located in the segment VIII and dilated right branch of portal vein (arrow in F). Note the presence of tortuous venous structures around the thrombosed portal vein indicating portal cavernoma. The spleen was moderately enlarged with dilated splenic vein (extra-hepatic portal hypertension).")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px",
      "padding-top": "15px"
    }
  }, [_c('strong', [_vm._v("Diagnosis:")]), _vm._v(" Hepatic Hydatid Cyst ruptured into the Portal Vein")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 90
// module chunks = 0